// SEQ=10124 P8-CK-H — Intrigue UX 오버레이
// 사양: SEQ-10119 §3-3 #4 + SEQ-10123 §1-2 #4
//   ── (a) 상대 활성 기사 클릭 → target_knight_id 확정
//      (b) 본인 도로 인접 vertex 클릭 → to_vertex_id 확정 (강제 이동)
//   ── 인접 검증은 클라 사전 집계 + 서버 SP 재검증 follow-up
import { CatanKnight, CatanPlayer } from '../../store/catan'

export interface IntrigueMoveOverlayProps {
  step: 'pick_knight' | 'pick_to_vertex'
  pickedKnight?: CatanKnight | null
  candidateVertexIds: number[]
  players: CatanPlayer[]
  onCancel: () => void
}

export default function IntrigueMoveOverlay({
  step, pickedKnight, candidateVertexIds, players, onCancel,
}: IntrigueMoveOverlayProps) {
  const pickedNick = pickedKnight
    ? (players.find(p => p.userCode === pickedKnight.userCode)?.nickname ?? `유저 ${pickedKnight.userCode}`)
    : null

  return (
    <div style={overlay}>
      <div style={card}>
        <div style={title}>🕵️ 음모 (Intrigue)</div>
        {step === 'pick_knight' ? (
          <div style={body}>
            <div>① 강제 이동시킬 <b>상대 활성 기사</b>를 클릭하세요.</div>
            <div style={hint}>본인 기사는 선택할 수 없습니다.</div>
          </div>
        ) : (
          <div style={body}>
            <div>① 기사 선택: <b>{pickedNick}</b> (knight #{pickedKnight?.knightId})</div>
            <div>② 강제 이동할 <b>본인 도로 인접 vertex</b>를 클릭하세요.</div>
            <div style={hint}>후보 vertex {candidateVertexIds.length}개 (보드 highlight).</div>
          </div>
        )}
        <div style={footer}>
          <button onClick={onCancel} style={btnSec}>취소</button>
        </div>
      </div>
    </div>
  )
}

const overlay: React.CSSProperties = { position: 'fixed', top: 12, right: 12, zIndex: 950, pointerEvents: 'none' }
const card:    React.CSSProperties = { background: '#fff', border: '1px solid #888', borderRadius: 6, padding: 12, minWidth: 240, boxShadow: '0 2px 8px rgba(0,0,0,0.2)', pointerEvents: 'auto' }
const title:   React.CSSProperties = { fontWeight: 'bold', marginBottom: 6, fontSize: 14 }
const body:    React.CSSProperties = { fontSize: 12 }
const hint:    React.CSSProperties = { fontSize: 11, color: '#666', marginTop: 4 }
const footer:  React.CSSProperties = { marginTop: 8, textAlign: 'right' }
const btnSec:  React.CSSProperties = { padding: '4px 10px', background: '#eee', border: '1px solid #aaa', borderRadius: 3, cursor: 'pointer' }
